import { PERSPECTIVE_IDS } from "./perspectiveIds";

/** Mapbox style URLs used by the main Midpoint map (and available for future basemap pickers). */
export const MAP_STYLE_URLS = {
  light: "mapbox://styles/mapbox/light-v11",
  dark: "mapbox://styles/mapbox/dark-v11",
  streets: "mapbox://styles/mapbox/streets-v12",
  satellite: "mapbox://styles/mapbox/satellite-streets-v12",
};

export const DEFAULT_MAP_STYLE = MAP_STYLE_URLS.light;

// Weather defaults to a dark basemap because radar returns are easier to read
// and coarse composite tile edges are less visually harsh.
export const WEATHER_MAP_STYLE = MAP_STYLE_URLS.dark;

/** Resolve the basemap for a perspective. Non-weather perspectives keep the light default. */
export function resolveMapStyleForPerspective(perspectiveId) {
  if (perspectiveId === PERSPECTIVE_IDS.WEATHER) {
    return WEATHER_MAP_STYLE;
  }

  return DEFAULT_MAP_STYLE;
}
